import { createFileRoute } from '@tanstack/react-router';
import { RouteGuard } from '../../../lib/route-guard.js';
import { LocationCreateForm } from '../../../modules/locations/location-create-form.js';

export const Route = createFileRoute('/warehouses/$locationGroupId/new')({
  component: NewLocationPage,
});

// eslint-disable-next-line react-refresh/only-export-components
function NewLocationPage() {
  const { locationGroupId } = Route.useParams();

  return (
    <RouteGuard route="/warehouses/$locationGroupId/new">
      <div>
        <LocationCreateForm
          defaultLocationGroupId={locationGroupId}
          cancelHref="/warehouses/$locationGroupId"
          cancelParams={{ locationGroupId }}
        />
      </div>
    </RouteGuard>
  );
}
